module.exports = __webpack_public_path__ + "static/13-4ec6c5e02745e677451bcc3b2302fe6f.jpg";